import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { UserPreferences } from './UserPreferences'

const Settings = observer(() => {
  return (
    <Box width="full" background="grey000White" alignItems="center">
      <UserPreferences />
    </Box>
  )
})

export default Settings
